import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewOrderLayer from "../components/ViewOrderLayer";

const ViewOrderPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Order Details' />

        {/* AddBlogLayer */}
        <ViewOrderLayer />
      </MasterLayout>
    </>
  );
};

export default ViewOrderPage;